<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="epartMaterialNumber"
      [label]="'case.fields.epartMaterialNumber.label' | translate"
      [helpText]="'case.fields.epartMaterialNumber.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="epartDescription"
      [label]="'case.fields.epartDescription.label' | translate"
      [helpText]="'case.fields.epartDescription.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="familyName"
      [label]="'case.fields.familyName.label' | translate"
      [helpText]="'case.fields.familyName.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownFamilyNameType,
        entry1: form.get('familyName')?.value || ''
      }"
      [entry]="'entry1'"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="familyVariant"
      [label]="'case.fields.familyVariant.label' | translate"
      [helpText]="'case.fields.familyVariant.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownFamilyVariantType,
        entry1: form.get('familyVariant')?.value || ''
      }"
      [entry]="'entry1'"
  ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
  <app-textarea-form-field
    formControlName="reportedIssueDescription"
    [label]="'case.fields.reportedIssueDescription.label' | translate"
    [helpText]="'case.fields.reportedIssueDescription.help'"
    [viewMode]="viewMode"
    [textareaRows]="5"
  ></app-textarea-form-field>
  </div>
  <div class="col-12 col-md-4">
    <app-datepicker-form-field
      formControlName="assignedInvestigatorDate"
      [label]="'case.fields.assignedInvestigatorDate.label' | translate"
      [helpText]="'case.fields.assignedInvestigatorDate.help'"
      [viewMode]="viewMode"
      [maxDate]="datepickerMaxDate"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="epartBuildDate"
      [label]="'case.fields.epartBuildDate.label' | translate"
      [helpText]="'case.fields.epartBuildDate.help'"
      [viewMode]="viewMode"
      [maxDate]="datepickerMaxDate"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-input-form-field
      formControlName="internalInvestigationNumber"
      [label]="'case.fields.internalInvestigationNumber.label' | translate"
      [helpText]="'case.fields.internalInvestigationNumber.help'"
      [viewMode]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-datepicker-form-field
      formControlName="epartReceivedDate"
      [label]="'case.fields.epartReceivedDate.label' | translate"
      [helpText]="'case.fields.epartReceivedDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-configuration-select-form-field
      formControlName="rootCause"
      [label]="'case.fields.rootCause.label' | translate"
      [helpText]="'case.fields.rootCause.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownRootCause,
        entry1: form.get('rootCause')?.value || ''
      }"
      [entry]="'entry1'"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-input-form-field
      formControlName="epartSerialNumber"
      [label]="'case.fields.epartSerialNumber.label' | translate"
      [helpText]="'case.fields.epartSerialNumber.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-datepicker-form-field
      formControlName="nonConformanceDate"
      [label]="'case.fields.nonConformanceDate.label' | translate"
      [helpText]="'case.fields.nonConformanceDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-checkbox-form-field
      formControlName="reportUploaded"
      [label]="'case.fields.reportUploaded.label' | translate"
      [helpText]="'case.fields.reportUploaded.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-textarea-form-field
      formControlName="additionalEpartsInfo"
      [label]="'case.fields.additionalEpartsInfo.label' | translate"
      [helpText]="'case.fields.additionalEpartsInfo.help'"
      [viewMode]="viewMode"
    ></app-textarea-form-field>
  </div>
</div>
